<template>
  <div class="share-community">
    <!-- 邀请加入Nexa粉丝社群 -->
    <div class="title">Invitation to join the {{ projectInfo.brandName }} fan community</div>
    <!-- 顾客通过扫码您的进群邀请码加入WhatsApp群组，你可获取 xxx 积分奖励 -->
    <div class="community-tip">Customers can join the WhatsApp group by scanning your invitation code, and you can get {{ communityConfig.inviteIntegral }} points as a reward.</div>
    <div ref="qrCodeRef" class="img-code"></div>
    <!-- 每日最高可获取 xxx 积分 -->
    <div class="notice-tip" v-if="communityConfig.isQuota">You can get up to {{ communityConfig.dayTopIntegral }} points per day.</div>
  </div>
</template>

<script>
import { inviteCreateInviteCodeApi } from '@/api'
import { Toast } from 'vant'
import QRCode from 'qrcodejs2'
export default {
  data () {
    return {
      qrcodeUrl: null,
      communityConfig: {}
    }
  },
  mounted () {
    this.getCommunityCodeData()
  },
  methods: {
    getCommunityCodeData () {
      Toast.loading({
        message: 'loading...',
        forbidClick: true,
        duration: 0
      })
      inviteCreateInviteCodeApi().then(res => {
        Toast.clear()
        this.communityConfig = res.data
        this.qrcodeUrl = new QRCode(this.$refs.qrCodeRef, {
          text: res.data.inviteUrl,
          width: this.$refs.qrCodeRef.offsetWidth,
          height: this.$refs.qrCodeRef.offsetHeight,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.M
        })
      }).catch(() => {
        Toast.clear()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.share-community {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 30px;
  padding-top: 100px;
  overflow: hidden;
  font-size: 12px;
  color: #333;
  .title {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
  }
  .community-tip {
    text-align: center;
    font-size: 14px;
    margin: 20px 0;
  }
  .img-code {
    width: 200px;
    height: 200px;
  }
  .notice-tip {
    margin-top: 26px;
  }
}
</style>
